import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../reducers'

export const selectStaffState = createSelector(
  [(state: RootState) => state.staff],
  staff => ({
    staffData: staff.data,
    totalCount: staff.totalCount,
    loading: staff.loading,
    error: staff.error,
    filter: staff.filter,
    keyword: staff.keyword,
    columnFilters: staff.columnFilters,
    page: staff.page,
    pageSize: staff.pageSize,
    sort: staff.sort,
    currentStaff: staff.currentEntity,
    currentRoles: staff.currentRoles,
    pagination: {
      current: staff.page,
      pageSize: staff.pageSize,
      total: staff.totalCount,
    },
  }),
)
